module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-timeline"
  }, [_c('ul', {
    class: {
      'el-timeline': true,
      'is-reverse': _vm.reverse
    }
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.steps.length > _vm.displayCount) ? _c('rt-button-more', {
    staticClass: "rt-xpc-timeline-more",
    attrs: {
      "expanded-suffix-icon": "rt-base-arrow-up-lined",
      "collapsed-suffix-icon": "rt-base-arrow-down-lined"
    },
    on: {
      "change": _vm.changeExpand
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c7e67b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/timeline/rtTimeline.vue
// module id = 2102
// module chunks = 137